import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Icon from '../icon'
import { fromNow } from '../../lib/dates'

export default function NotificationItem({
  actor,
  created_at: createdAt,
  notify_type: notifyType,
  read_at: readAt,
  target,
  onNotificationClick,
  onActorClick,
}) {
  const { t } = useTranslation()

  const content = {
    title: target?.event?.title ? target.event.title : target?.title,
    name: target && target.name ? target.name : null,
  }

  const when = fromNow(createdAt)

  // Get verb and what text from translations
  let verb = notifyType
    ? t(`NotificationItem.notify_${notifyType}.verb`, { defaultValue: '' })
    : ''
  let what = notifyType
    ? t(`NotificationItem.notify_${notifyType}.what`, content)
    : ''

  // Default fallback
  if (!verb || !what) {
    verb = t('NotificationItem.notify_default.verb', { defaultValue: 'liked' })
    what = t('NotificationItem.notify_default.what', content)
  }

  const handleClick = () => {
    if (onNotificationClick) {
      onNotificationClick({
        actor,
        notifyType,
        target,
        createdAt,
        readAt,
      })
    }
  }

  const handleActorClick = (e) => {
    e.stopPropagation()
    if (onActorClick) {
      onActorClick(actor)
    }
  }

  return (
    <div
      className={`notification-item ${!readAt ? 'unread' : ''}`}
      onClick={handleClick}
    >
      <div className="notification-content">
        <div className="notification-actor-section">
          {actor?.media_attachment ? (
            <img
              className="notification-actor-image"
              src={actor.media_attachment.resized_image_url || actor.media_attachment.direct_upload_url}
              alt={actor.name}
            />
          ) : (
            <div className="notification-actor-icon">
              <Icon name="circle-user" />
            </div>
          )}
        </div>
        
        <div className="notification-text-container">
          <div className="notification-text">
            <span 
              className="notification-actor-name"
              onClick={handleActorClick}
            >
              {actor?.name || 'Unknown User'}
            </span>
            <span className="notification-verb">{` ${verb}`}</span>
            <span className="notification-what">{` ${what}`}</span>
            <span className="notification-when">{` ${when}`}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

NotificationItem.propTypes = {
  actor: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    media_attachment: PropTypes.shape({
      resized_image_url: PropTypes.string,
      direct_upload_url: PropTypes.string,
    }),
  }),
  created_at: PropTypes.string.isRequired,
  notify_type: PropTypes.string,
  read_at: PropTypes.string,
  target: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    name: PropTypes.string,
    event: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  onNotificationClick: PropTypes.func,
  onActorClick: PropTypes.func,
}
